import { render, staticRenderFns } from "./PublishForm.vue?vue&type=template&id=57698f78&scoped=true"
import script from "./PublishForm.vue?vue&type=script&lang=js"
export * from "./PublishForm.vue?vue&type=script&lang=js"
import style0 from "./PublishForm.vue?vue&type=style&index=0&id=57698f78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57698f78",
  null
  
)

export default component.exports